<aayn-ad-preview-card [selectedPlatform]="Platforms.Google" [platforms]="platforms">
  <aayn-ad-preview-google-tabs
    [availableTabs]="['search']"
    [titles]="adPreviewService.searchAds.headlines"
    [linkUrl]="adPreviewService.searchAds.url || ''"
    [description]="adPreviewService.searchAds.description || ''"
  >
  </aayn-ad-preview-google-tabs>
</aayn-ad-preview-card>
